import { observer } from "mobx-react-lite";
import { useContext } from "react";

import { IContextualMenuItem, PrimaryButton } from "@bps/fluent-ui";
import { AppointmentInformationModalContext } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/appointment-information/AppointmentInformationModalContext.ts";

interface AppointmentInformationEditButtonProps {
  selectionCount: number | undefined;
}

export const AppointmentInformationEditButton: React.FC<AppointmentInformationEditButtonProps> =
  observer(({ selectionCount }) => {
    const helper = useContext(AppointmentInformationModalContext);
    const getMenuItems = () => {
      const items: IContextualMenuItem[] = [];
      if (helper.isDnaOrCanceledStatus) {
        items.push({
          key: "reschedule",
          text: "Reschedule",
          onClick: helper.onRescheduleOrCreateCopyClick
        });
      } else {
        items.push(
          {
            key: "createCopy",
            text: "Create a copy",
            onClick: helper.onRescheduleOrCreateCopyClick
          },
          {
            key: "cancelAppointment",
            text: "Cancel appointment",
            onClick: helper.onCancelClick
          }
        );
      }

      return items;
    };
    return (
      <PrimaryButton
        onClick={helper.onEditClick}
        text="Edit"
        disabled={!selectionCount}
        split
        menuProps={{ items: getMenuItems() }}
      />
    );
  });
